module.exports = __webpack_public_path__ + "img/zhoubianyou.8f9cae71.png";